// extracted by mini-css-extract-plugin
export default {"Text":"RemovedFromProjectV2Event-module__Text--iKzZo","Text_1":"RemovedFromProjectV2Event-module__Text_1--v82mO","Text_2":"RemovedFromProjectV2Event-module__Text_2--ISVRT"};